import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import React, { useEffect, useState } from "react";
import {
  genElText,
  genElObject,
  genElNumber,
  genElDate,
  genElTextArea,
  genElTextDropdown,
} from "../../../../../components/utils/EditorDialogElementGenerator";
import { ProgressSpinner } from "primereact/progressspinner";
import CustomerSelectorMain from "../../../../selectors/customer-selector/component/customer-selector-main";
import { el } from "date-fns/locale";
import { useSelector } from "react-redux";
import ProductSelectorMain from "../../../../selectors/product-selector/component/product-selector-main";
import ProductSelectorDialog from "../../../../../dialogs/selectors/ProductSelectorDialog";
import { useAPIEditOfferRewardVoucher } from "../../api/voucher/api-edit-voucher";

// PART_IMPORT_SELECTOR_DIALOG

const OfferRewardVoucherEdit = (props) => {
  const { visible, onHide, editorData, onConfirmed } = props;
  const employee = useSelector((state) => state.auth.employee);

  const {
    loading,
    data,
    setData,
    fetchDataOrCreateNew,
    error,
    handleOnConfirm,
  } = useAPIEditOfferRewardVoucher({ onConfirmed });

  // PART_DIALOG_STATE
  const [showCustomerSelector, setShowCustomerSelector] = useState(false);
  const [showProductSelector, setShowProductSelector] = useState(false);

  // use effect section

  useEffect(() => {
    if (visible) {
      fetchDataOrCreateNew({ id: editorData.id, extraData: editorData });
    }
  }, [visible]);

  // handle ui event section

  // genereate editor element section

  // PART_HANDLE_SELECTOR

  const handleOnClickCustomer = () => {
    setShowCustomerSelector(true);
  };

  const handleOnConfirmCustomer = (event, datas) => {
    let selected;
    event.preventDefault();
    if (datas && datas.length > 0) {
      selected = datas[0];
      setData({ ...data, data_customer: selected, customer_id: selected.id });
      setShowCustomerSelector(false);
    }
    return selected;
  };

  const handleOnClickProduct = () => {
    setShowProductSelector(true);
  };

  const handleOnConfirmProduct = (event, datas) => {
    let selected;
    event.preventDefault();
    if (datas && datas.length > 0) {
      selected = datas[0];
      setData({ ...data, data_product: selected, product_id: selected.id });
      setShowProductSelector(false);
    }
    return selected;
  };

  // PART_FIELDS_GENERATOR

  const elCustomer = genElObject({
    field: 'customer_id',
    name: 'Customer',
    value: data.data_customer ? data.data_customer.name : '',
    onClick: handleOnClickCustomer,
    error,
  });

  const elExpiredDate = genElDate({
    field: 'expired_date',
    name: 'Expired Date',
    data,
    setData,
    error,
    disabled: true,
  });

  const elRequestExpiredDate = genElDate({
    field: 'request_expired_date',
    name: 'Request Expired Date',
    data,
    setData,
    error,
  });

  const elVoucher = genElText({
    field: 'name',
    name: 'Voucher Name',
    data,
    setData,
    error,
  });

  const elAmount = genElNumber({
    field: 'amount',
    name: 'Amount',
    data,
    setData,
    error,
  });

  const elDescription = genElTextArea({
    field: 'description',
    name: 'Description',
    data,
    setData,
    error,
  });

  const dialogFooter = (
    <React.Fragment>
      <Button
        label="Cancel"
        icon="pi pi-times"
        outlined
        onClick={props.onHide}
      />
      <Button
        label="Save"
        icon="pi pi-check"
        onClick={(e) => {
          handleOnConfirm();
        }}
        loading={loading}
      />
    </React.Fragment>
  );

  return (
    <Dialog
      visible={visible}
      style={{ width: "50rem" }}
      breakpoints={{ "960px": "75vw", "641px": "90vw" }}
      header={data.id && data.id > 0 ? "Edit Request" : "Add Request"}
      modal
      className={`p-fluid`}
      footer={dialogFooter}
      onHide={onHide}
      contentClassName="py-4 !pb-6"
      pt={{ footer: { className: "py-4" }, header: { className: "py-4" } }}
    >
      {/* PART_SELECTOR_DIALOG */}

      <CustomerSelectorMain
        title={'Select Customer'}
        visible={showCustomerSelector}
        onHide={() => setShowCustomerSelector(false)}
        onConfirm={handleOnConfirmCustomer}
        additionalFilter={employee?.user_type == 3 ? `bc_id:=:${employee.id}` : ''}
      />

      <ProductSelectorDialog
        title={'Select Product'}
        visible={showProductSelector}
        onHide={() => setShowProductSelector(false)}
        onConfirm={handleOnConfirmProduct}
        additionalFilter={``}
      />

      <div className="col-start-center relative h-100 gap-3">
        {/* PART_FIELDS_RENDER */}
        {elCustomer}
        <div className="row-start-start w-full gap-2">
          {elVoucher}
          {elExpiredDate}
        </div>
        {elRequestExpiredDate}
        {elAmount}
        {elDescription}
        {loading && (
          <div
            className={`col-center-center w-100  gap-2 absolute z-100 h-100 bg-black/20 rounded `}
          >
            <ProgressSpinner />
          </div>
        )}
      </div>
    </Dialog>
  );
};

export default OfferRewardVoucherEdit;
